var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo29(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 32,
    viewBox: "0 0 23 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.02981 0.001691C1.3522 -0.00632978 0.67535 0.0212849 0 0.0628899C0 10.6893 0 21.3158 0 31.9422C1.29662 32.0324 2.6055 32.0162 3.89858 31.8996C4.27673 30.6465 4.66426 29.395 5.04601 28.1425C7.03008 27.8152 8.93575 27.1988 10.6355 26.3279C12.0224 26.9974 13.4086 27.6677 14.7958 28.3368C15.8051 27.7046 16.7257 26.9995 17.5637 26.2294C16.7167 25.1225 15.8658 24.0175 15.0173 22.9114C16.1232 21.5513 16.9408 20.0293 17.3188 18.4359C18.9058 18.1309 20.4925 17.8248 22.0797 17.5205C22.1765 16.5056 22.1641 15.4843 22.0394 14.4712C20.4627 14.1675 18.8856 13.8646 17.3088 13.5612C16.9191 11.9693 16.147 10.4352 15.0105 9.0884C15.8618 7.98247 16.7117 6.87587 17.5637 5.77035C16.7467 4.98607 15.8344 4.28101 14.8394 3.63903C13.4344 4.31937 12.0278 4.99767 10.6221 5.67722C8.93307 4.7876 7.02555 4.15274 5.0393 3.82795C4.65478 2.57112 4.26876 1.31458 3.88516 0.0575682C3.26788 0.020665 2.6491 -0.00728682 2.02981 0.001691ZM5.1366 7.18591C10.0524 8.27147 13.7556 12.1809 13.5075 16.254C13.3829 20.1167 9.93185 23.7986 5.18357 24.7846C4.95768 24.4821 5.14979 23.7442 5.08569 23.2732C5.08365 17.9072 5.0816 12.5413 5.07956 7.17527L5.1366 7.18591Z",
    fill: "url(#paint0_linear_9494_16610)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9494_16610",
    x1: 1.49267,
    y1: 20.0941,
    x2: 1.49267,
    y2: -36.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008000",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo29);
export default __webpack_public_path__ + "static/media/logo29.a1846207f70a496c522010b210fe24a3.svg";
export { ForwardRef as ReactComponent };